import _ from 'lodash';

const P = {
  funtionName: 'funtionName',
  displayOrder: 'displayOrder',
  systemActions: 'systemActions',
  permissionId: 'permissionId',
  systemFuncs: 'systemFuncs',
  functionType: 'functionType',
  // userRole
  permisssions: 'permisssions',
  parentId: 'parentId',
  roleTypeId: 'roleTypeId',
};

const C = {
  menu: 1,
  function: 2,
};

const PermissionListFunc = {
  getPermissions: (allData) => {
    return allData ? allData[P.permisssions] : null;
  },
  getAllActions: function (allData) {
    const permissions = this.getPermissions(allData);
    return permissions
      ? permissions.filter((item) => {
          return item[P.functionType] === C.function;
        })
      : null;
  },
  orderAllActions: function (allData) {
    const allActions = this.getAllActions(allData);
    return allActions
      ? _.sortBy(allActions, (item) => {
          return item[P.displayOrder];
        })
      : null;
  },
  isPermissionList: function (allActions, userPermissionIds) {
    return _.map(allActions, (item) => {
      return userPermissionIds.includes(item[P.permissionId]);
    });
  },
  getAllSystemFuncs: function (allData) {
    const permissions = this.getPermissions(allData);
    return permissions
      ? permissions.filter((item) => {
          return item[P.functionType] === C.menu;
        })
      : null;
  },
  orderAllSystemFuncs: function (allData) {
    const allSystemFuncs = this.getAllSystemFuncs(allData);
    return allSystemFuncs
      ? _.orderBy(allSystemFuncs, (item) => {
          return item[P.displayOrder];
        })
      : null;
  },
};

const permissionFunc = {
  getPermissionId: (allData) => {
    return allData ? allData[P.permissionId] : null;
  },
  getFuntionName: (allData) => {
    return allData ? allData[P.funtionName] : null;
  },
  getParentId: (allData) => {
    return allData ? allData[P.parentId] : null;
  },
};

const userPermissionFunc = {
  getPermisssions: (allData) => {
    return allData ? allData[P.permisssions] : null;
  },
  getAllIds: function (allData) {
    const Permisssions = this.getPermisssions(allData);
    return _.map(Permisssions, (item) => {
      return item[P.permissionId];
    });
  },
  getActiontPermisssions: function (allData) {
    const permisssions = this.getPermisssions(allData);
    return _.filter(permisssions, (item) => {
      return item[P.functionType] === C.function;
    });
  },
  getActionIds: function (allData) {
    const actiontPermisssions = this.getActiontPermisssions(allData);
    return _.map(actiontPermisssions, (item) => {
      return item[P.permissionId];
    });
  },
  getRoleTypeId: function (allData) {
    return allData ? allData[P.roleTypeId] : null;
  },
};

export { permissionFunc, userPermissionFunc, PermissionListFunc, C as functionTypeE };
